<template>
  <div class="dashboard-container">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-content">
            <div class="stat-icon"><i class="el-icon-s-order"></i></div>
            <div class="stat-info">
              <h3>订单总数</h3>
              <p class="num">{{ stats.totalOrders }}</p>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-content">
            <div class="stat-icon"><i class="el-icon-user-solid"></i></div>
            <div class="stat-info">
              <h3>用户总数</h3>
              <p class="num">{{ stats.totalUsers }}</p>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="clearfix">
            <span>近期活动 (Top 10)</span>
          </div>
          <el-table :data="upcomingEvents" style="width: 100%">
            <el-table-column prop="name" label="活动名称"></el-table-column>
            <el-table-column prop="eventTime" label="活动时间" width="200"></el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { vpost } from "@/util/post";

export default {
  name: "Dashboard",
  data() {
    return {
      stats: { totalOrders: 0, totalUsers: 0 },
      upcomingEvents: []
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      vpost("/dashboard/stats").then(res => {
        if (res.code === 200) this.stats = res.data;
      });
      vpost("/dashboard/upcoming").then(res => {
        if (res.code === 200) this.upcomingEvents = res.data;
      });
    }
  }
};
</script>

<style scoped>
.stat-card .stat-content { display: flex; align-items: center; }
.stat-icon { font-size: 48px; color: #409EFF; margin-right: 20px; }
.stat-info h3 { margin: 0; font-size: 16px; color: #999; }
.stat-info .num { margin: 10px 0 0; font-size: 32px; font-weight: bold; color: #333; }
</style>
